import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { SessionProvider } from './SessionContext';
import { Toaster } from 'sonner';

// Add Tailwind directives
import 'tailwindcss/tailwind.css';
import '@fontsource/poppins/300.css';  // light
import '@fontsource/poppins/400.css';  // regular
import '@fontsource/poppins/500.css';  // medium
import '@fontsource/poppins/600.css';  // semibold

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <div className="min-h-screen bg-[#f2f2f2] font-poppins">
        <Toaster position="top-right" richColors />
        <SessionProvider>
          <App />
        </SessionProvider>
      </div>
    </BrowserRouter>
  </React.StrictMode>
);